export default __webpack_public_path__ + "static/media/buy_cad_bond.fbb76679.svg";